import React from 'react'
import DepositBadge from 'views/depositBadge/DepositBadge'
import PropTypes from 'prop-types'
import styles from './viewLayout.module.sass'

const isTurnOffDeposit = (process.env.REACT_APP_TURN_OFF_DEPOSIT === 'true')

function ViewLayout({
  children, backgroundImg, backgroundTitle, customizedStyles,
}) {
  return (
    <div
      className={styles.root}
      style={{
        'backgroundImage': `url(${backgroundTitle}), url(${backgroundImg})`,
      }}
    >
      <div className={styles.leftTrack} />
      <div className={styles.centerContent}>
        <div
          className={styles.content}
          style={{
            marginTop: customizedStyles && customizedStyles.contentMarginTop,
          }}

        >
          {children}
        </div>
      </div>
      <div className={styles.rightTrack}>
        {!isTurnOffDeposit && <DepositBadge />}
      </div>
    </div>

  )
}
ViewLayout.propTypes = {
  children: PropTypes.object,
  backgroundImg: PropTypes.string,
  backgroundTitle: PropTypes.string,
  customizedStyles: PropTypes.object,

}

ViewLayout.defaultProps = {
  children: {},
  backgroundImg: '',
  backgroundTitle: '',
  customizedStyles: {},

}
export default ViewLayout
